import { Component, Input, OnInit } from '@angular/core';
import { TipoColunaEnum } from 'src/app/shared/tabela-crud/model/tipo-coluna.enum';;
import { AcoesCrudEnum } from '../tabela-acoes.enum';

@Component({
  selector: 'app-celula-tabela',
  templateUrl: './celula-tabela.component.html',
  styleUrls: ['./celula-tabela.component.css']
})
export class CelulaTabelaComponent implements OnInit {

  // objeto que será exibido na tabela
  @Input() objeto: any;

  // nome da coluna que será exibida na tabela
  @Input() coluna: string;

  // tipo da coluna
  @Input() tipo: TipoColunaEnum;

  // propriedade usada no HTML representando as ações CRUD
  readonly acoesCrud: typeof AcoesCrudEnum = AcoesCrudEnum;

  linkLogoEmpresa: string = '#';

  constructor() { }

  ngOnInit(): void {
    if (this.objeto.empresaLogo) {
      this.linkLogoEmpresa = `${this.objeto.empresaLogo}`
    }
    this.exibirValorNaTabela(this.objeto, this.coluna);
  }

  // permite a exibição de dados de objetos simples e aninhados
  exibirValorNaTabela(elemento: any, coluna: string): any {
    return coluna.split('.').reduce((valorAnterior, valorAtual) => valorAnterior[valorAtual], elemento);
  }

  get TipoColuna(){
    return TipoColunaEnum;
  }
}
